import TheGrid from '@/views/sales/sellinnew/grid'

export default {
  path: '/sales/sellinnew',
  redirect: '/sales/sellinnew/index',
  name: 'Sellin',
  meta: {
    auth: {
      redirect: {
        name: 'sellinnew.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Sellin'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'sellinnew.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Vendas'
    }
  }]
}
